export enum PRE_JOINER_STATUS {
  ACTIVE = "active",
  NEW = "new",
  CANCELLED = "cancelled",
}

export const STATUS_TEXT = {
  [PRE_JOINER_STATUS.CANCELLED]: "CANCELLED",
  [PRE_JOINER_STATUS.ACTIVE]: "ACTIVE",
  [PRE_JOINER_STATUS.NEW]: "NEW",
};

export const STATUS_COLORS: Record<string, string[]> = {
  ERROR: [PRE_JOINER_STATUS.CANCELLED],
  SUCCESS: [PRE_JOINER_STATUS.ACTIVE],
  DEFAULT: [PRE_JOINER_STATUS.NEW],
};
